export namespace DimensionUnit {
  export const MM = "mm";
  export const CM = "cm";
  export const M = "m";
  export const IN = "in";
  export const FT = "ft";
  export const YD = "yd";
}

export type DimensionUnit =
  | typeof DimensionUnit.MM
  | typeof DimensionUnit.CM
  | typeof DimensionUnit.M
  | typeof DimensionUnit.IN
  | typeof DimensionUnit.FT
  | typeof DimensionUnit.YD;

export const dimensionUnits = [
  DimensionUnit.MM,
  DimensionUnit.CM,
  DimensionUnit.M,
  DimensionUnit.IN,
  DimensionUnit.FT,
  DimensionUnit.YD,
] as const;

const INCHES_PER_UNIT: Record<DimensionUnit, number> = {
  [DimensionUnit.MM]: 1 / 25.4,
  [DimensionUnit.CM]: 1 / 2.54,
  [DimensionUnit.M]: 39.3701,
  [DimensionUnit.IN]: 1,
  [DimensionUnit.FT]: 12,
  [DimensionUnit.YD]: 36,
};

export function convertLength(
  value: number,
  from: DimensionUnit,
  to: DimensionUnit,
): number {
  if (from === to) {
    return value;
  }
  const valueInInches = value * INCHES_PER_UNIT[from];
  return valueInInches / INCHES_PER_UNIT[to];
}

export function computeVolumeInCubicInches(
  length: number,
  width: number,
  height: number,
): number {
  return length * width * height;
}

export interface BoxDimensions {
  length: number;
  width: number;
  height: number;
  unit: DimensionUnit;
}

/**
 * Hundredths of an inch, the precision carriers accept for a parcel.
 * Undefined when a side rounds to 0 in, which no carrier can rate.
 */
export function boxDimensionsToInches(
  box: BoxDimensions,
): { length: number; width: number; height: number } | undefined {
  const toInches = (value: number) =>
    Math.round(convertLength(value, box.unit, DimensionUnit.IN) * 100) / 100;
  const inches = {
    length: toInches(box.length),
    width: toInches(box.width),
    height: toInches(box.height),
  };
  return inches.length > 0 && inches.width > 0 && inches.height > 0
    ? inches
    : undefined;
}
